<template>
    <div class="flex flex-col mx-auto max-w-3xl w-full text-center">
        <span class="text-2xl">Assurances Xiaomi</span>
        <span class="text-gray-600">Souscription en magasin</span>

        <div class="flex flex-col md:flex-row justify-center space-y-5 md:space-y-0 md:space-x-0 md:space-x-10 my-10">
            <button @click="selectType('phone_breakage')" class="h-32 md:w-48 flex flex-col bg-xiaomi hover:bg-xiaomi-darker cursor-pointer text-white rounded-lg items-center justify-center text-xl">
                <span>Téléphone</span>
            </button>
            <button disabled @click="selectType('trottinette')" class="h-32 md:w-48 flex bg-red-500 hover:bg-red-600 cursor-not-allowed text-white rounded-lg items-center justify-center text-xl">
                <span>Trottinette</span>
            </button>
            <button disabled @click="selectType('nomade')" class="h-32 md:w-48 flex bg-pink-500 hover:bg-pink-600 cursor-not-allowed text-white rounded-lg items-center justify-center text-xl">
                <span>Nomade</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        selectType: function(type) {
            this.$emit('select-type', type);
        }
    }
}
</script>